import { useEffect, useRef } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { fetchCustomerPermissions } from '../api/new-customers';
import { permissions as permissionsStore, permissionsMetaData } from '../store/permissions';

export const usePermissions = (customerId, userInfo) => {
  const [permissionsMap, setPermissionsMap] = useAtom(permissionsStore);
  const resetData = useResetAtom(permissionsStore);
  const [meta, setMeta] = useAtom(permissionsMetaData);
  const resetMeta = useResetAtom(permissionsMetaData);
  const dataRef = useRef({ meta, permissionsMap });
  dataRef.current.meta = meta;
  dataRef.current.permissionsMap = permissionsMap;

  useEffect(() => {
    if (!userInfo || !customerId || dataRef.current.meta[customerId]?.error) return;
    const permissions = dataRef.current.permissionsMap[customerId];
    if (!dataRef.current.meta[customerId]?.loading && !permissions) {
      setMeta(prev => ({ ...prev, [customerId]: { loading: true } }));

      fetchCustomerPermissions(customerId)
        .then(p => {
          setPermissionsMap(prev => ({ ...prev, [customerId]: p }));
          setMeta(prev => ({ ...prev, [customerId]: { loading: false } }));
        })
        .catch(e => {
          setMeta(prev => ({ ...prev, [customerId]: { error: e, loading: false } }));
          // eslint-disable-next-line no-console
          console.warn(`Failed to fetch permission for customer ${customerId}`);
        });
    }
  }, [customerId, userInfo]);

  const resetPermissions = () => {
    resetData();
    resetMeta();
  };

  return {
    resetPermissions,
    permissions: permissionsMap[customerId],
    loading: meta[customerId]?.loading,
    error: meta[customerId]?.error
  };
};

export const usePermissionsData = customerId => {
  const permissionsMap = useAtomValue(permissionsStore);
  const meta = useAtomValue(permissionsMetaData);

  return {
    permissions: permissionsMap[customerId],
    loading: meta[customerId]?.loading
  };
};

export const useResetPermissions = () => useResetAtom(permissionsMetaData);
